import {
  OPERATIONS,
  NETWORK,
  FLEET,
  RATE,
  PRICING,
  FINANCE,
  ACCOUNT,
  PAYOUT,
  TASK,
  ANALYTICS,
  AUTOMATION,
  ROLZOLOCATIONS,
  SUPPORT,
} from './types'

export const operationsTab = () => dispatch => {
  dispatch({
    type: OPERATIONS,
  })
}
export const networkTab = () => dispatch => {
  dispatch({
    type: NETWORK,
  })
}
export const taskTab = () => dispatch => {
  dispatch({
    type: TASK,
  })
}
export const fleetTab = () => dispatch => {
  dispatch({
    type: FLEET,
  })
}
export const ratesTab = () => dispatch => {
  dispatch({
    type: RATE,
  })
}
export const pricingTab = () => dispatch => {
  dispatch({
    type: PRICING,
  })
}
export const financeTab = () => dispatch => {
  dispatch({
    type: FINANCE,
  })
}
export const automationTab = () => dispatch => {
  dispatch({
    type: AUTOMATION,
  })
}
export const accountTab = () => dispatch => {
  dispatch({
    type: ACCOUNT,
  })
}
export const payoutTab = () => dispatch => {
  dispatch({
    type: PAYOUT,
  })
}
export const analyticsTab = () => dispatch => {
  dispatch({
    type: ANALYTICS,
  })
}
export const rolzoLocationsTab = () => dispatch => {
  dispatch({
    type: ROLZOLOCATIONS,
  })
}
export const supportTab = () => dispatch => {
  dispatch({
    type: SUPPORT,
  })
}
